var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormValidation',{attrs:{"initData":{ title:'Edit Personal Information', btn:'Edit' },"formObj":_vm.formObj},on:{"submit":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }